import { Form } from "antd";
import styled, { css } from "styled-components";

import { Palette } from "../../../../core/styles/palette";

const baseStyle = css`
    // select nested div in aevi container that contains aevi label and form input
    &.aevi-form-field-horizontal div:has(> .aevi-form-field-label):has(> .aevi-form-field-input) {
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    // select nested div in aevi container that contains aevi label and form input
    &.aevi-form-field-vertical div:has(> .aevi-form-field-label):has(> .aevi-form-field-input) {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
`;

const formFieldStyle = css`
    &.aevi-form-field {
        gap: 15px;
        margin-bottom: 0;
    }

    // "required" asterix styling
    &.aevi-form-field:has([aria-required="true"]) .aevi-form-field-label::after {
        content: " *";
        color: red;
        margin-left: 5px;
    }

    &.aevi-form-field-label {
        // width configured in FormFieldRender
        font-family: "RobotoLight";
        font-size: 12pt;
        font-weight: 100;
        color: ${Palette.AeviBlack};
        text-align: right;
        //padding: 0 15px;
        line-height: 17pt;
        vertical-align: middle;
        overflow-x: hidden;
    }

    &.aevi-form-field-input {
        // width configured in FormFieldRender
        margin-top: auto;
        margin-bottom: auto;
    }

    &.aevi-form-field-horizontal {
        .aevi-form-field-label {
            //padding: 0 15px;
            width: 30%;
            text-align: right;
        }

        .aevi-form-field-input {
            width: 70%;
        }
    }

    &.aevi-form-field-vertical {
        .aevi-form-field-label {
            min-width: 100%;
            text-align: left;
            padding: 0;
        }

        .aevi-form-field-input {
            width: 100%;
        }
    }
`;

const ActionFormField = styled(Form.Item)`
    ${baseStyle};
    ${formFieldStyle};
`;

const ActionFormFieldDiv = styled.div`
    ${formFieldStyle};
    ${baseStyle};
`;

export const HorizontalFormFieldStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field aevi-form-field-horizontal",
}))<{ hiddenLabel?: boolean }>`
    ${({ hiddenLabel }) => hiddenLabel && "display: none;"}
`;

export const VerticalFormFieldStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field aevi-form-field-vertical",
}))``;

export const VerticalFormFieldStyleDiv = styled(ActionFormFieldDiv).attrs(() => ({
    className: "aevi-form-field aevi-form-field-vertical",
}))``;

export const FormFieldInputStyle = styled(ActionFormField).attrs(() => ({
    className: "aevi-form-field-input",
}))``;

export const FormFieldLabelStyle = styled.label.attrs(() => ({ className: "aevi-form-field-label" }))`
    ${formFieldStyle};
`;
